module.exports = __webpack_public_path__ + "img/female-elderly-foot.8e3c1df1.svg";